/* eslint-disable @typescript-eslint/no-empty-function */
import { useEffect } from 'react'
import { onPageEnter } from 'lib/tracking/pageEnter'
import MetaInformation from 'components/modules/SEO/Meta'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetServerSideProps } from 'next'
import styled from 'styled-components'
import { parseLocale } from 'lib/constants/localization'
import FoxWink from 'assets/authorization-flow/fox-wink.webp'
import _useTranslation from 'lib/hooks/_useTranslation'
import { StandardHeadline } from 'stories/elements/Typography/Text'
import SideSection from 'stories/layouts/SideSection'
import SignUpFlow from 'components/feature/Authentication/SignupFlow'
import Stack from 'components/elements/Stack'
import theme from 'stories/utils/theme'

const BackgroundImage = styled.img``

const SectionWrapper = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    width: 500px;
    gap: 30px;
    padding: 0 5%;
    div {
        width: 450px !important;
        margin: 0;
        @media (max-width: 750px) {
            width: 300px !important;
        }
    }
    @media (max-width: 1050px) {
        width: 100%;
        padding: 5%;
        justify-content: start;
    }
`

function SignUp({ customTitle }: { customTitle?: string }) {
    const { t } = _useTranslation('auth')

    useEffect(() => {
        onPageEnter()
    }, [])

    const pageTitle = customTitle || t('auth/signUpRegisterPageSubtitle')

    return (
        <SideSection
            image={
                <Stack>
                    <StandardHeadline textAlign="center" fontFamily="var(--font-inter)" color={theme.colors.white}>
                        {pageTitle}
                    </StandardHeadline>
                    <BackgroundImage src={FoxWink.src} width={450} height={450} alt="Create an account" />
                </Stack>
            }
        >
            <MetaInformation title={pageTitle} description={t('auth/signUpRegisterPageHeading')} canonical />
            <SectionWrapper>
                <SignUpFlow isDarkTheme />
            </SectionWrapper>
        </SideSection>
    )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const { title } = context.query

    return {
        props: {
            ...(await serverSideTranslations(parseLocale(context.locale).interfaceLanguageCode, ['common', 'auth'])),
            customTitle: typeof title === 'string' ? title : null,
        },
    }
}

export default SignUp
